export const faqs = [
  {
    q: 'Is this a traditional HVAC electrical textbook?',
    a: 'No. HVAC Electrical Troubleshooting Blueprint™ is a practical digital toolkit focused on troubleshooting organization, decision maps, verification planning, and documentation. The materials are designed for professional application rather than passive study.',
  },
  {
    q: 'Who should use this product?',
    a: 'Qualified HVAC technicians, service technicians, maintenance professionals, and other appropriately trained professionals involved in HVAC electrical troubleshooting. It is not designed to replace foundational electrical training.',
  },
  {
    q: 'Does this system cover HVAC control circuits?',
    a: 'Yes. The package includes structured investigation tools for control circuits, relays, contactors, thermostats, safety circuits, and related electrical components. Equipment-specific procedures must always follow the applicable manufacturer documentation.',
  },
  {
    q: 'Does the blueprint include wiring diagram tools?',
    a: 'Yes. Volume 02 provides practical worksheets and circuit-mapping tools for organizing investigations using manufacturer wiring diagrams.',
  },
  {
    q: 'Will this blueprint diagnose every HVAC electrical problem?',
    a: 'No. The blueprint provides a structured process for organizing troubleshooting activities and documenting findings. Actual diagnostic conclusions depend on equipment conditions, professional competence, appropriate testing, manufacturer specifications, and available evidence.',
  },
  {
    q: 'Can I use this system while working on HVAC equipment?',
    a: 'The worksheets and reference materials can support qualified professionals during service planning, documentation, and approved troubleshooting activities. They must never replace applicable electrical safety requirements, workplace procedures, or manufacturer instructions.',
  },
  {
    q: 'Does the product teach energized electrical testing?',
    a: 'No. The product does not authorize or independently instruct unqualified individuals to perform energized electrical work. Electrical testing must be conducted only by appropriately qualified personnel using approved procedures, suitable equipment, and applicable protective measures.',
  },
  {
    q: 'Is this a physical book?',
    a: 'No. This is a digital product. You’ll receive access to the six practical volumes and five complementary resources after purchase.',
  },
  {
    q: 'Are the five bonuses included?',
    a: 'Yes. All five professional bonuses are included in the $27 purchase.',
  },
  {
    q: 'Is there a monthly subscription?',
    a: 'No. The $27 offer is a one-time payment.',
  },
  {
    q: 'How quickly will I receive access?',
    a: 'Your digital materials will be available immediately after successful purchase.',
  },
  {
    q: 'Is there a guarantee?',
    a: 'Yes. Your purchase includes a seven-day money-back guarantee.',
  },
];
